import * as Job_events_bs$SolvuuApi0 from "./job_events_bs.bs.js";
import * as Service_get_events_response_bs$SolvuuApi0 from "./service_get_events_response_bs.bs.js";
var read_ok = Job_events_bs$SolvuuApi0.read_t;
var write_ok = Job_events_bs$SolvuuApi0.write_t;
var read_not_found = Service_get_events_response_bs$SolvuuApi0.read_not_found;
var write_not_found = Service_get_events_response_bs$SolvuuApi0.write_not_found;
var read_bad_request = Service_get_events_response_bs$SolvuuApi0.read_bad_request;
var write_bad_request = Service_get_events_response_bs$SolvuuApi0.write_bad_request;
export { read_ok, write_ok, read_not_found, write_not_found, read_bad_request, write_bad_request };
/* Job_events_bs-SolvuuApi0 Not a pure module */